import { Controller } from "@hotwired/stimulus"
import { syncReceivablesOverview } from "../utils/overview-sync.util"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    this.restoreState()
  }

  toggle() {
    if (this.toggleTarget.checked) {
      this.#ensureDefaultIssuedTo()
    }
    this.updateFrame()
  }

  restoreState() {
    const url = new URL(window.location.href)
    this.toggleTarget.checked = url.searchParams.get("forecast") === "true"
  }

  updateFrame() {
    const turboFrame = document.getElementById("documents")
    if (!turboFrame) return

    const url = new URL(window.location.href)

    if (this.toggleTarget.checked) {
      url.searchParams.set("forecast", "true")
    } else {
      url.searchParams.delete("forecast")
    }

    history.pushState(null, "", url)
    turboFrame.setAttribute("src", url)
    syncReceivablesOverview(this.application, url.searchParams)
  }

  #ensureDefaultIssuedTo() {
    const url = new URL(window.location.href)
    if (url.searchParams.get("issuedTo")) return

    const year = new Date().getFullYear()
    const iso = `${year}-12-31`

    url.searchParams.set("issuedTo", iso)
    history.replaceState(null, "", url)

    const issuedToInput = document.getElementById("issuedTo")
    if (issuedToInput) {
      issuedToInput.value = iso
    }
  }
}
